import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import { TextSpan } from 'app/typography';
import Loader from 'components/Kizen/Loader';

const StyledLoadingOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    padding-top: 0 !important;
    margin-right: 5px;
  }
`;

export const NoOptionsMessage = ({ children, ...propsNoOption }) => {
  const { t } = useTranslation();
  return (
    <components.NoOptionsMessage {...propsNoOption}>
      <StyledLoadingOption>
        <Loader loading size={20} />
        <TextSpan style={{ color: 'var(--color-font-placeholder)' }}>
          {t('Loading...')}
        </TextSpan>
      </StyledLoadingOption>
    </components.NoOptionsMessage>
  );
};
